import { render, staticRenderFns } from "./feature-gated-stamp.vue?vue&type=template&id=1d0eb2a0&"
import script from "./feature-gated-stamp.vue?vue&type=script&lang=ts&"
export * from "./feature-gated-stamp.vue?vue&type=script&lang=ts&"
import style0 from "./feature-gated-stamp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports